import React from 'react'
import './navbar.css';

export default function NavBar(props) {

    //for Desktop

    window.addEventListener('wheel', (event) => {
        if (event.deltaY > 0) {
            document.getElementById('NavbarBody').style.transition = '.8s all';
            document.getElementById('NavbarBody').style.transform = 'translateY(-150%)';

        } else if (event.deltaY < 0) {
            document.getElementById('NavbarBody').style.transition = '.8s all';
            document.getElementById('NavbarBody').style.transform = 'translateY(0%)';
        }
    });

    window.addEventListener('scroll', () => {
        if (window.screen.width > 860) {
            window.scrollY !== 0 ? document.getElementById('NavbarBody').className = 'NavbarBody active' : document.getElementById('NavbarBody').className = 'NavbarBody';
        }
    })


    //for Touch Devices

    let startingY, movingY;
    document.addEventListener('touchstart', function (e1) {
        startingY = e1.touches[0].clientY;
    });

    document.addEventListener('touchmove', function (e1) {
        movingY = e1.touches[0].clientY;
    });

    document.addEventListener('touchend', function () {
        if (startingY + 20 < movingY) {
            document.getElementById('NavbarBody').style.transition = '.8s all';
            document.getElementById('NavbarBody').style.transform = 'translateY(0%)';

        } else if (startingY - 20 > movingY) {
            document.getElementById('NavbarBody').style.transition = '.8s all';
            document.getElementById('NavbarBody').style.transform = 'translateY(-150%)';
        }
    });

    const customTheme = (color) => {
        document.documentElement.style.setProperty('--theme', color);

        // Get the computed value of the --theme variable
        let themeColor = color.trim();

        // Extract the hue, saturation, and lightness values from the theme color
        let [h, s, l] = themeColor.match(/-?\d*\.?\d+/g).map(Number);

        // Set the --theme-hue, --theme-saturation, and --theme-lightness variables
        document.documentElement.style.setProperty('--theme-hue', `${h}deg`);
        document.documentElement.style.setProperty('--theme-saturation', `${s}%`);
        document.documentElement.style.setProperty('--theme-lightness', `${l}%`);

    }


    return (
        <div className={`NavbarBody ${window.screen.width <= 860 ? 'active' : ''}`} id='NavbarBody'>
            <div className="nav-container">
                <div className="logo">

                </div>
                <ul className='menu'>
                    <li className={props.activeNav === 0 ? 'nav-active' : ''}><a href="#home">&#47;&#47; home</a></li>
                    <li className={props.activeNav === 1 ? 'nav-active' : ''}><a href="#skill">&#47;&#47; skills</a></li>
                    <li className={props.activeNav === 2 ? 'nav-active' : ''}><a href="#projects">&#47;&#47; projects</a></li>
                    <li className={props.activeNav === 3 ? 'nav-active' : ''}><a href="#todo">&#47;&#47; to-do</a></li>
                </ul>
                <div className="color-palette">
                    <div className="bg-color-btn" style={{ background: 'hsl(0deg 100% 50%)' }} onClick={() => { customTheme('hsl(0deg 100% 50%)') }}></div>
                    <div className="bg-color-btn" style={{ background: 'hsl(32.54deg 100% 88.43%)' }} onClick={() => { customTheme('hsl(32.54deg 100% 88.43%)') }}></div>
                    <div className="bg-color-btn" style={{ background: 'hsl(174deg 72.07% 56.47%)' }} onClick={() => { customTheme('hsl(174deg 72.07% 56.47%)') }}></div>
                    <div className="bg-color-btn" style={{ background: 'hsl(196.94deg 100% 50%)' }} onClick={() => { customTheme('hsl(196.94deg 100% 50%)') }}></div>
                </div>
            </div>
        </div>
    )
}
